export const DEFAULT_PAYOUT = {
  date: null,
  accruedInterest: 0,
  fileNo: null,
  accountId: null,
  summary: [],
  amount: 0,
  name: null
}
